export const assets = {
  logo: 'assets/images/logo.png',
  adminIcon: 'assets/images/profile.png',
  placeHolderLogo: 'assets/images/placeholder.png',
  sidebarDashboardIcon: 'assets/images/dash.svg',
  viewIcon: 'assets/images/eye.svg',
  edit_icon: 'assets/images/edit_icon.svg',
  deleteIcon: 'assets/images/delete_icon.svg',
  RevenueIcon: 'assets/images/revenue.svg',
  ReveiwIcon: 'assets/images/rating.svg',
  CmsIcon: 'assets/images/cms.svg',
  LogoutIcon: 'assets/images/logout.svg',
  CategoryIcon: 'assets/images/category.svg',
  cartIcon: 'assets/images/cart_icon.svg',
  userIcon: 'assets/images/user_icon.svg',
  playStore: 'assets/images/play_store.svg',
  appStore: 'assets/images/app_store.svg',
  defaultProperty: 'assets/images/prp_img.png',
  ReportIcon: 'assets/images/reports.svg',
  searchIcon: 'assets/images/search_icon.svg',
  UsersIcon: 'assets/images/total_user.svg',
  VendorIcon: 'assets/images/vendor_icon.svg',
  ProductIcon: 'assets/images/product_icon.svg',
  OrderIcon: 'assets/images/order_icon.svg',
  AdIcon: 'assets/images/ad_icon.svg',
  AnalyticIcon: 'assets/images/analytic_icon.svg',
  CouponsIcon: 'assets/images/coupons_icon.svg',
  bannerImage: 'assets/images/home_banner.jpg',
  starIcon: 'assets/images/star_icon.svg',
  giftHer: 'assets/images/gift_her.jpg',
  giftHim: 'assets/images/gift_him.jpg',
  passHide: 'assets/images/pass_hide_icon.svg',
  facebook: 'assets/images/facebook_icon.svg',
  twitter: 'assets/images/twitter_icon.svg',
  insta: 'assets/images/insta_icon.svg',
  googlePlus: 'assets/images/google_plus.svg',
  apple: 'assets/images/apple_icon.svg',
  wishFill: 'assets/images/wish_fill.svg',
  deliverIcon: 'assets/images/deliver_icon.svg',
  tickShape: 'assets/images/tick_shape.svg',
  phoneIcon: 'assets/images/phone_icon.svg',
  emailIcon: 'assets/images/email_icon.svg',
  addressIcon: 'assets/images/address_icon.svg',
  packedIcon: 'assets/images/pacekd_icon.svg',
  orderImage: 'assets/images/order_img.jpg',
  openEyes: 'assets/images/open_eyes.svg',
  filterIcon: 'assets/images/filter_icon.svg',
  colorImg: 'assets/images/color_img.png',
  InfoIcon: 'assets/images/info_icon.svg',
  DateIcon: 'assets/images/date_icon.svg',
  WrapIcon: 'assets/images/wrap_icon.svg',
  fiveStar: 'assets/images/five_star.svg',
  couponIcon: 'assets/images/coupons_icon.svg',
  checkproduct: 'assets/images/check_product.png',
  trashIcon: 'assets/images/trash_icon.svg',
  cardIcon: 'assets/images/visa_icon.svg',
  calenderDateIcon: 'assets/images/calenderDate_icon.svg',
  timeIcon: 'assets/images/time_icon.svg',
  VideoIcon: 'assets/images/upload_video.svg',
  payIcon: 'assets/images/pay_done.png',
  changePassIcon: 'assets/images/change_pass.svg',
  PaymentIcon: 'assets/images/pay_icon.svg',
  giftVideoPoster: 'assets/images/gift_video.jpg',
  PlayVideoIcon: 'assets/images/play_video.svg',
  deliveryTruckIcon: 'assets/images/deliveryTruck_icon.svg',
  ZoomIcon: 'assets/images/zoom_icon.svg',
  sortIcon: 'assets/images/sort_icon.svg',
  AuthBg: 'assets/images/auth_bg.png',
  cameraIcon: 'assets/images/camera.svg',
  splashBg: 'assets/images/splash_bg.png',
  introBg1: 'assets/images/intro_bg_1.png',
  introBg2: 'assets/images/intro_bg_2.png',
  introBg3: 'assets/images/intro_bg_3.png',
  propImage: 'assets/images/prp_img.png',
  locationIcon: 'assets/images/location_icon.svg',
  areaBg: 'assets/images/area_bg.jpg',
  ads: 'assets/images/ad_1.jpg',

  rightArrow: 'assets/images/right_arrow.svg',
  collection1: 'assets/images/collection1.jpg',
  collection2: 'assets/images/collection2.jpg',
  collection3: 'assets/images/collection3.jpg',
  collection4: 'assets/images/collection4.jpg',
  quote: 'assets/images/quote.svg',
  logo2: 'assets/images/logo2.png',
  contactImg: 'assets/images/contact_img.png',
  profileImage: 'assets/images/profile.png',
  badgeIcon: 'assets/images/badge_icon.svg',
  flagIcon: 'assets/images/flag.svg',
  waitApprove: 'assets/images/wait_approve.png',
  googleIcon: 'assets/images/google_plus.svg',
  instaIcon: 'assets/images/insta_icon.svg',
  twiterIcon: 'assets/images/twitter_icon.svg',
  linkedIcon: 'assets/images/link_icon.svg',
  noDataFound: 'assets/images/no-data.svg',
  trash: 'assets/images/trash.svg',
  catImage: 'assets/images/cat_img2.png',
  send: 'assets/images/send.png',
  pdf: 'assets/images/pdf.png'
} as const;
